import { captureException } from '@sentry/browser';
import axios from 'axios';
import type {
    ExecutionStatus,
    ExternalNetworkMapPort,
    OrganizationNetwork,
} from '../core/networkMap/ExternalNetworkMapPort';
import type { SessionId } from '../core/domain/Session';

export class ExternalNetworkMapProvider implements ExternalNetworkMapPort {
    constructor(private readonly baseEndpoint: string) {}

    async loadNetworkMapData(): Promise<OrganizationNetwork> {
        try {
            const response = await axios.request<OrganizationNetwork>({
                method: 'POST',
                url: `${this.baseEndpoint}/network-map`,
                withCredentials: true,
            });

            return response.data;
        } catch (err) {
            console.error(err);
            captureException(err);
            throw err;
        }
    }

    async loadSessionNetworkData(sessionId: SessionId): Promise<OrganizationNetwork> {
        try {
            const response = await axios.request<OrganizationNetwork>({
                method: 'GET',
                url: `${this.baseEndpoint}/network-map/sessions/${sessionId}`,
                withCredentials: true,
            });

            return response.data;
        } catch (err) {
            console.error(err);
            captureException(err);
            throw err;
        }
    }

    async refreshExecutionStatuses(): Promise<Array<ExecutionStatus>> {
        try {
            const response = await axios.request<Array<ExecutionStatus>>({
                method: 'GET',
                url: `${this.baseEndpoint}/network-map/executions`,
                withCredentials: true,
            });

            return response.data;
        } catch (err) {
            console.error(err);
            captureException(err);
            throw err;
        }
    }
}
